var render = function render(){var _vm=this,_c=_vm._self._c;return _c('phone-number-input',{ref:"input",model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }